import React from "react";
import { useNavigate } from 'react-router-dom';
import { MessageSquare, Video, PhoneCall, Star } from "lucide-react";

const DoctorCard = ({ doctor }) => {
  const navigate = useNavigate();
  // Fallbacks for missing data
  const photo = doctor.photo || doctor.avatar || "https://randomuser.me/api/portraits/men/7.jpg";
  const name = doctor.name || "Dr. John Doe";
  const specialty = doctor.specialty || doctor.specialisation || doctor.specialization || "General Practitioner";
  const years = doctor.yearsExperience || doctor.experience || "7+ Years Experience";
  const rating = doctor.rating || 4.9;
  const reviews = doctor.reviewsCount || doctor.reviews || 125;
  const online = doctor.online || doctor.status === "Online now" || doctor.status === "Available";

  return (
    <div
     
      style={{
        background: "#fff",
        borderRadius: 20,
        boxShadow: "0 4px 24px rgba(80, 0, 200, 0.07)",
        padding: 12,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        margin: "0 8px 16px 0",
        border: "none",
        cursor: 'pointer',
        transition: 'box-shadow 0.15s',
      }}
      onClick={() => doctor._id && navigate(`/doctor-details/${doctor._id}`)}
      tabIndex={0}
      onKeyDown={e => { if (e.key === 'Enter' && doctor._id) navigate(`/doctor-details/${doctor._id}`); }}
      aria-label={`View profile for ${name}`}
    >
      {/* Doctor Photo + Online Indicator */}
      <div style={{ position: "relative", marginBottom: 12 }}>
        <img
          src={photo}
          alt={name}
          style={{
            width: 62,
            height: 62,
            borderRadius: "50%",
            objectFit: "cover",
            border: "none",
            background: "#f3f0ff",
            boxShadow: "0 2px 8px rgba(124,77,255,0.08)",
          }}
        />
        {online && (
          <span
            style={{
              position: "absolute",
              bottom: 6,
              right: 6,
              width: 12,
              height: 12,
              background: "#22c55e",
              border: "2px solid #fff",
              borderRadius: "50%",
              boxShadow: "0 0 0 2px #fff",
              display: "block",
            }}
          />
        )}
      </div>
      {/* Name & Experience */}
      <div style={{ textAlign: "center", width: "100%" }}>
        {/* Doctor name with last name always breaking to new line */}
        <div style={{ fontWeight: 700, fontSize: 15, color: "#222", marginBottom: 0, lineHeight: 1.35, wordBreak: 'break-word' }}>
          {(() => {
            const parts = name.split(' ');
            if (parts.length > 1) {
              return <>{parts.slice(0, -1).join(' ')}<br />{parts[parts.length - 1]}</>;
            }
            return name;
          })()}
        </div>
        <div style={{ color: "#7c7c8a", fontSize: 12, fontWeight: 500, marginBottom: 0, lineHeight: 1.35 }}>{years} yrs exp.</div>
        <div style={{ color: "#7c3aed", fontWeight: 600, fontSize: 13, marginBottom: 0, lineHeight: 1.35 }}>{specialty}</div>
      </div>
      {/* Rating */}
      <div style={{ display: "flex", alignItems: "center", gap: 4, margin: "10px 0 0 0" }}>
        <Star size={15} color="#facc15" fill="#facc15" style={{ marginBottom: -2 }} />
        <span style={{ fontWeight: 700, fontSize: 13, color: '#222' }}>{rating}</span>
        <span style={{ color: "#7c7c8a", fontSize: 11, fontWeight: 500 }}>({reviews})</span>
      </div>
      {/* Divider */}
      <div style={{ width: '100%', borderBottom: '1px solid #f1f1f6', margin: '12px 0 0 0' }} />
      {/* Action Icons */}
      <div style={{ display: "flex", justifyContent: "space-between", width: '100%', gap: 0, marginTop: 6 }}>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", color: "#7c3aed", cursor: "pointer" }}>
          <MessageSquare size={19} strokeWidth={1.7} style={{ color: '#7c3aed' }} />
          <span style={{ fontSize: 11, marginTop: 2, color: '#7c3aed', fontWeight: 500 }}>Chat</span>
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", color: "#7c3aed", cursor: "pointer" }}>
          <PhoneCall size={19} strokeWidth={1.7} style={{ color: '#7c3aed' }} />
          <span style={{ fontSize: 11, marginTop: 2, color: '#7c3aed', fontWeight: 500 }}>Audio</span>
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", color: "#7c3aed", cursor: "pointer" }}>
          <Video size={19} strokeWidth={1.7} style={{ color: '#7c3aed' }} />
          <span style={{ fontSize: 11, marginTop: 2, color: '#7c3aed', fontWeight: 500 }}>Video</span>
        </div>
      </div>
    </div>
  );
};

export default DoctorCard;